import {useQuery} from '@apollo/react-hooks';

import type {
    GetLeadsSearchResults as GetLeadsSearchResultsQuery,
    GetLeadsSearchResultsVariables as GetLeadsSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_LEADS_SEARCH_RESULTS from '../queries/get-leads-search-results.graphql';

export const useGetLeads = (
    query?: string | null
): {
    isLoading: boolean;
    leads: any[];
    refetch: () => Promise<any>;
    fetchMore: (searchTerm?: string | null | undefined) => Promise<any>;
} => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetLeadsSearchResultsQuery,
        GetLeadsSearchResultsQueryVariables
    >(GET_LEADS_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
            limit: 10,
        },
        notifyOnNetworkStatusChange: true,
    });

    const leadResults =
        data && data.search && data.search.quickResults && data.search.quickResults.leadResults
            ? data.search.quickResults.leadResults
            : [];

    return {
        leads: leadResults,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm?: string | null) => {
            return fetchMore({
                query: GET_LEADS_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                    limit: 10,
                },
                // @ts-expect-error
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
